import { InspectionTypeEnum } from "../../../models/enums/inspection-type.enum";
import Inspection from "../../../models/inspection.entity";

class InspectionPayloadService {
  public formatPayloadBetweenCPForCNPJ(inspection: Inspection, document: string) {
    const selectedType: string = localStorage.getItem('inspection-type') || '';

    const obj: any = {
      name: inspection.name,
      email: inspection.email,
      cellphone: inspection.cellphone.replace(/[()-]/g, '').replace(' ', ''),
      is_agricultural_machinery: !!(selectedType === InspectionTypeEnum.AGRICULTURAL_MACHINE),
      notes: inspection.notes
    };

    if (document === 'cpf') {
      obj.cpf = inspection.cpf.replace(/[-.]/g, '');
    } else if (document === 'cnpj') {
      obj.cnpj = inspection.cnpj.replace(/[.\-/]/g, '');
    }

    if (inspection.plate && inspection.plate.length === 7) {
      obj.plate = inspection.plate;
    }

    if (inspection.chassis) {
      obj.chassis = inspection.chassis;
    }

    if (inspection.plate && inspection.plate.length === 17) {
      obj.chassis = inspection.plate;
    }

    if (inspection.inspectionId) {
      obj.inspection_id = inspection.inspectionId;
    }

    return obj;
  }

  public formatPayloadSimplesCPF(inspection: Inspection) {
    const selectedType: string = localStorage.getItem('inspection-type') || '';
    const obj: any = {
      cpf: inspection.cpf.replace(/[-.]/g, ''),
      name: inspection.name,
      email: inspection.email,
      cellphone: inspection.cellphone.replace(/[()-]/g, '').replace(' ', ''),
      is_agricultural_machinery: !!(selectedType === InspectionTypeEnum.AGRICULTURAL_MACHINE)
    };

    if (inspection.plate && inspection.plate.length === 7) {
      obj.plate = inspection.plate;
    }

    if (inspection.chassis) {
      obj.chassis = inspection.chassis;
    }

    if (inspection.plate && inspection.plate.length === 17) {
      obj.chassis = inspection.plate;
    }

    if (inspection.inspectionId) {
      obj.inspection_id = inspection.inspectionId;
    }

    return obj;
  }
}
export default new InspectionPayloadService();
